(function(){
  var VARS=['--c1','--c2','--wash','--n1','--n2','--n3','--ivory','--paper','--ink','--body','--muted','--line','--dh','--dt','--dm','--dline'];
  function s(x){return (typeof x==='string'&&x.trim())?x.trim():null}
  function arr(x){if(!x||!x.length)return null;var o=[];for(var i=0;i<x.length;i++){if(s(x[i]))o.push(s(x[i]))}return o.length?o:null}
  function esc(x){return String(x==null?'':x).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}

  try{
    if(typeof P!=='undefined'&&P.detox&&P.detox.th){
      P.detox.th.c1='#FF4D97'; P.detox.th.c2='#B455E0'; P.detox.th.wash='#FFF0F6';
      P.detox.th.n1='#150610'; P.detox.th.n2='#34122B'; P.detox.th.n3='#22082C';
    }
  }catch(e){}

  try{
    if(typeof S!=='undefined'&&S.length){
      for(var q=0;q<S.length;q++){
        var it=S[q]; if(!it)continue;
        if(it.d) it.d=String(it.d).replace(/20\d\d/g,'').replace(/[·•,\-–\s]+$/,'').trim();
        if(it.t) it.t=String(it.t).replace(/\s*(?:بداية|منتصف|نهاية|عام|سنة|في)?\s*20\d\d\s*[،,]?/g,' ').replace(/\s{2,}/g,' ').trim();
      }
      var pri={'جلسات':0,'رصد':1,'ثراء':2,'عام':4,'تحليل':9};
      function key(x){
        var t=(x.t||'')+' '+(x.tag||'');
        if(/تحليل|البصمة الفلكية|بصمة/.test(t))return 9;
        var p=pri[x.tag]; return p==null?5:p;
      }
      S.sort(function(a,b){return key(a)-key(b)});
    }
  }catch(e){}

  function applyMeta(){
    var M=window.ZKM||{},p=window.ZKPAGE;
    if(!p||typeof P==='undefined'||!P[p])return;
    var t=P[p];
    if(s(M.eyebrow))t.type=s(M.eyebrow);
    if(s(M.title))t.title=s(M.title);
    if(s(M.sub))t.sub=s(M.sub);
    if(s(M.hook))t.hook=s(M.hook);
    if(s(M.result))t.result=s(M.result);
    var b=arr(M.bullets); if(b)t.bullets=b;
    var g=arr(M.tags); if(g)t.tags=g;
    if(s(M.date_value)){
      var d=(t.dates||[]).slice();
      if(!d.length)d=[['','']];
      d[0]=[s(M.date_label)||d[0][0]||'',s(M.date_value)];
      t.dates=d;
    }
    if(s(M.countdown))t.cdDate=s(M.countdown);
  }

  function bundleMeta(){
    if(window.ZKPAGE!=='bundle')return;
    var M=window.ZKM||{},hero=document.querySelector('#zk .heroC');
    if(!hero)return;
    var e=hero.querySelector('.eyebrow'); if(e&&s(M.eyebrow))e.textContent=s(M.eyebrow);
    var h=hero.querySelector('h1');
    if(h&&(s(M.title)||s(M.sub)))h.innerHTML=(s(M.title)||'')+(s(M.sub)?' <span class="thin">'+esc(s(M.sub))+'</span>':'');
    var l=hero.querySelector('.lead'); if(l&&s(M.hook))l.textContent=s(M.hook);
  }

  function buttons(){
    var C=(window.ZK&&window.ZK.common)||{}, B2=(window.ZK&&window.ZK.bundle)||{}, M=window.ZKM||{};
    var p=window.ZKPAGE;
    function set(sel,val){ var v=s(val); if(!v)return; var e=document.querySelector(sel); if(e&&e.textContent.indexOf('جارٍ')<0)e.textContent=v; }
    set('#zk .hcta .btn-p', M.cta1);
    set('#zk .final .btn-p', M.cta2);
    set('#zk .hcta .btn-o', p==='bundle'?B2.btn2:C.btn2);
    set('#zk #bundle .btn-p', C.btn_band);
    set('#sb .btn-p', C.btn_sticky);
    if(p==='bundle'){ set('#zk .sec.dark.t2 .btn-p', B2.btn_mid); }
    var v=s(C.btn_details);
    if(v){ var d=document.querySelectorAll('#zk #system .btn-o'); for(var i=0;i<d.length;i++)d[i].textContent=v; }
  }

  function bundleLink(){
    if(window.ZKPAGE==='bundle')return;
    var C=(window.ZK&&window.ZK.common)||{};
    var b=document.getElementById('bundle'); if(!b||b.querySelector('.zk-more'))return;
    var p=b.querySelector('.btn-p'); if(!p||!p.parentNode)return;
    var dark=!!b.closest('.dark')||/dark/.test(b.className||'');
    var a=document.createElement('a');
    a.className='btn btn-o zk-more'+(dark?'':' lite');
    a.href=(s(C.bundle_url)||'/products/timebundle26');
    a.textContent=s(C.btn_more)||'اكتشفي تفاصيل الباقة كاملة';
    p.parentNode.insertBefore(a,p.nextSibling);
  }

  function words(){
    var app=document.getElementById('app'); if(!app)return;
    var w=document.createTreeWalker(app,NodeFilter.SHOW_TEXT); var n;
    while((n=w.nextNode())){
      var t=n.nodeValue, o=t;
      t=t.replace(/دليل طقوس الطهارة/g,'طقوس الطهارة');
      if(t!==o)n.nodeValue=t;
    }
  }

  function skySec(){
    var Z=(window.ZK&&window.ZK.sky)||{};
    var app=document.getElementById('app'); if(!app||app.querySelector('#sky12'))return;
    var items=[];
    for(var i=1;i<=12;i++){ var t=s(Z['t'+i]); if(t)items.push([t,s(Z['d'+i])||'']); }
    if(!items.length)return;
    var cards='';
    for(var j=0;j<items.length;j++){
      var n=(j+1)<10?('0'+(j+1)):String(j+1);
      cards+='<div class="icard"><div class="b"><span class="kk">'+n+'</span><h3>'+esc(items[j][0])+'</h3><p>'+esc(items[j][1])+'</p></div></div>';
    }
    var tw='';
    for(var k=0;k<12;k++){ tw+='<i'+(k%3===0?' class="b"':'')+' style="left:'+((k*29)%92+3)+'%;top:'+((k*37)%86+6)+'%;animation-duration:'+(3+(k%4))+'s;animation-delay:'+(k*0.35).toFixed(2)+'s"></i>'; }
    var html='<section class="sec dark t2" id="sky12"><div class="stars"></div><div class="twk">'+tw+'</div>'
      +'<div class="wrap"><div class="shead c"><span class="eyebrow">'+esc(s(Z.eyebrow)||'طاقة هذه الفترة')+'</span>'
      +'<h2 class="h-1">'+esc(s(Z.h_a)||'')+' <span class="thin">'+esc(s(Z.h_b)||'')+'</span></h2>'
      +(s(Z.lead)?'<p class="lead">'+esc(s(Z.lead))+'</p>':'')+'</div>'
      +'<div class="g g2">'+cards+'</div></div></section>';
    var box=document.createElement('div'); box.innerHTML=html;
    var sec=box.firstChild;
    var anchor=null, accs=app.querySelectorAll('.acc');
    if(accs.length) anchor=accs[accs.length-1].closest('section');
    if(!anchor){ var f=app.querySelector('.final'); anchor=f?(f.closest('section')||f):null; }
    if(anchor&&anchor.parentNode) anchor.parentNode.insertBefore(sec,anchor); else app.appendChild(sec);
  }

  function stripYear(){
    var n=document.querySelectorAll('#zk .tc .mt,#zk .qc .mt');
    for(var i=0;i<n.length;i++){
      var t=n[i].textContent.replace(/\s*[·•\-–]?\s*20\d\d\s*$/,'').replace(/\s*[·•\-–]\s*$/,'').trim();
      if(t!==n[i].textContent)n[i].textContent=t;
    }
  }

  function fixPlayer(){
    var ph=document.querySelector('#zk .player .ph'); if(!ph)return;
    var dot=ph.querySelector('.dot'); if(!dot)return;
    var t=dot.textContent.trim(); if(!t)return;
    var sib=dot.nextElementSibling; if(sib)sib.textContent=t;
    dot.textContent='';
  }

  function hx(h){h=(h||'').trim().replace('#','');if(h.length===3)h=h.split('').map(function(x){return x+x}).join('');
    if(h.length<6)return null;return [parseInt(h.slice(0,2),16),parseInt(h.slice(2,4),16),parseInt(h.slice(4,6),16)]}
  function rgbStr(a){return 'rgb('+a[0]+', '+a[1]+', '+a[2]+')'}
  function deep(a){return 'rgb('+Math.round(a[0]*.64+21*.36)+', '+Math.round(a[1]*.64+14*.36)+', '+Math.round(a[2]*.64+2*.36)+')'}
  function contrast(){
    var zk=document.getElementById('zk'); if(!zk)return;
    var st=getComputedStyle(zk), map=[];
    ['--c1','--c2'].forEach(function(v){ var a=hx(st.getPropertyValue(v)); if(a)map.push([rgbStr(a),deep(a)]); });
    if(!map.length)return;
    var all=zk.querySelectorAll('#app *');
    for(var i=0;i<all.length;i++){
      var el=all[i];
      if(el.closest('.dark'))continue;
      if(!el.textContent||!el.textContent.trim())continue;
      var col=getComputedStyle(el).color;
      for(var j=0;j<map.length;j++){ if(col===map[j][0]){ el.style.setProperty('color',map[j][1],'important'); break; } }
    }
  }

  function sync(){
    var zk=document.getElementById('zk'); if(!zk)return;
    var hs=document.documentElement.style;
    for(var i=0;i<VARS.length;i++){ var v=hs.getPropertyValue(VARS[i]); if(v&&v.trim())zk.style.setProperty(VARS[i],v.trim()); }
  }
  function ready(){
    try{ document.body.classList.add('zk-ready');
      var a=document.getElementById('app'); if(a){a.style.visibility='visible';a.style.opacity='1'}
    }catch(e){}
  }
  function polish(){
    try{sync()}catch(e){} try{skySec()}catch(e){} try{buttons()}catch(e){} try{bundleLink()}catch(e){}
    try{words()}catch(e){} try{fixPlayer()}catch(e){} try{stripYear()}catch(e){} try{contrast()}catch(e){}
  }

  setTimeout(ready,2000);
  try{document.body.classList.add('zk-live')}catch(e){}
  sync();
  try{ new MutationObserver(sync).observe(document.documentElement,{attributes:true,attributeFilter:['style']}); }catch(e){}

  try{ applyMeta(); }catch(e){}
  var p=window.ZKPAGE;
  if(p){ try{ go(p); }catch(e){ if(window.console)console.warn('zk',e); } }
  try{ bundleMeta(); }catch(e){}
  polish();

  var u=window.ZKSTORIES;
  function fix(){
    if(!u)return;
    var bs=document.querySelectorAll('#zk [data-goto="stories"]');
    for(var i=0;i<bs.length;i++){
      var b=bs[i]; if(b.__zk)continue; b.__zk=1;
      b.removeAttribute('data-goto'); b.style.cursor='pointer';
      b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();location.href=u},true);
    }
  }
  fix(); ready();
  setTimeout(function(){polish();fix()},500);
  setTimeout(function(){polish();fix()},1600);
  window.addEventListener('load',function(){polish();fix();ready()});
})();
